import React from 'react';
import { TrophyIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-143" data-mp="17ws2e8ti4mcx">
      <div className="mx-auto max-w-md" data-id="element-144" data-mp="1mmz95ra5cgxs">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-145" data-mp="1hophhqnmrygx">
          Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-146" data-mp="u0xvtwg7a92z">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-147" data-mp="13x14zm9gz7zf">
            Volleyball Ready™ Pack
          </span>

          <dl data-id="element-148" data-mp="2fb4zctjyyy50">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-149" data-mp="2ad3go9qgh0u2">
                <dt className="text-ink/80" data-id="element-150" data-mp="pjz3fuxdlhys">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-151" data-mp="uiiozu824rqm">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-152" data-mp="zi4zhvwi3tvq">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-153" data-mp="13iyqiy58posu">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-154" data-mp="6vamfk20jwsa">$225 USD</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-155" data-mp="bt2eqf6klkx0">
            Today only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-156" data-mp="klntlk72z7gk">
            <TrophyIcon className="h-8 w-8 shrink-0 text-brand" aria-hidden="true" data-id="element-157" data-mp="3k95m0jtrt7kt" />
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-158" data-mp="3o8win45zahx9">
              $19
            </span>
            <span className="self-end pb-2 text-sm font-bold text-brand" data-id="element-159" data-mp="vdwdar3hdqpp">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-160" data-mp="155k72ynifjuc">
            Payment will be processed in your local currency.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-161" data-mp="1078w2klhb3aj" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-162" data-mp="cgczla62vjwy">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}